// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","inner":"Footer_inner__CVEiR","links":"Footer_links__wMgLO","logo":"Footer_logo__+JiYo"};